import { chatQueryKeys as e } from "./useChatQueryKeys.mjs";
import { useQueryClient as t } from "@maat/store-hooks";
import { adminSupportChatApi as n } from "@maat/api-chat";
import { useEffect as r } from "react";
import { useSSEAdapter as i } from "@maat/store-sse";
//#region src/hooks/useAdminSupportSSE.ts
var a = (a) => {
	let o = t(), s = i();
	r(() => {
		if (!a) return;
		let t = s.open(n.getSSEUrl(), { withCredentials: !0 }), r = (t) => {
			let n;
			try {
				n = JSON.parse(t).conversation_id;
			} catch {
				return;
			}
			n && (o.invalidateQueries({ queryKey: e.adminSupportMessages(n) }), o.invalidateQueries({ queryKey: e.adminSupportNotes(n) })), o.invalidateQueries({ queryKey: e.adminSupportUnread() });
		};
		return t.addEventListener("new_message", r), t.addEventListener("new_note", r), () => t.close();
	}, [
		a,
		s,
		o
	]);
};
//#endregion
export { a as useAdminSupportSSE };
